<template>
    <!-- Sleep timer: stop after N minutes or at the end of the chapter. -->
    <div ref="root" class="relative">
        <button
            type="button"
            class="ab-sleep-btn"
            :class="{ 'is-on': player.sleep }"
            :aria-label="player.sleep ? `Sleep timer: ${label}. Change` : 'Sleep timer'"
            :aria-expanded="open"
            title="Sleep timer"
            @click="open = !open"
        >
            <player-icon name="timer" class="h-[18px] w-[18px]" />
            <span v-if="player.sleep" class="tabular-nums">{{ label }}</span>
        </button>
        <transition name="ab-pop">
            <div v-if="open" class="ab-sleep-menu" :class="up ? 'bottom-full mb-2' : 'top-full mt-2'" role="menu">
                <p class="ab-eyebrow px-4 pb-1 pt-2">Stop playing</p>
                <button v-for="o in options" :key="o" type="button" role="menuitemradio" class="ab-sleep-item" :aria-checked="isSet(o)" @click="choose(o)">
                    {{ o === 'end' ? 'At the end of the chapter' : `In ${o} minutes` }}
                    <player-icon v-if="isSet(o)" name="check" class="h-4 w-4" />
                </button>
                <button v-if="player.sleep" type="button" role="menuitem" class="ab-sleep-item ab-sleep-off" @click="choose(null)">Turn off timer</button>
            </div>
        </transition>
    </div>
</template>

<script>
import { player, setSleep, SLEEP_OPTIONS } from '../../helpers/audiobook'
import PlayerIcon from './playerIcon.vue'

export default {
    name: 'SleepTimer',
    components: { PlayerIcon },
    props: {
        up: { type: Boolean, default: true }, // open the menu above the button
    },
    data() {
        return { player, options: SLEEP_OPTIONS, open: false }
    },
    computed: {
        label() {
            const s = player.sleep
            if (!s) return ''
            if (s.end) return 'End'
            player.position // re-read as the chapter plays, so the countdown moves
            return `${Math.max(1, Math.ceil((s.endsAt - Date.now()) / 60000))}m`
        },
    },
    mounted() { document.addEventListener('pointerdown', this.outside) },
    unmounted() { document.removeEventListener('pointerdown', this.outside) },
    methods: {
        isSet(o) {
            const s = player.sleep
            return !!s && (o === 'end' ? !!s.end : s.minutes === o)
        },
        choose(o) {
            setSleep(o)
            this.open = false
        },
        outside(e) {
            if (this.open && !this.$refs.root.contains(e.target)) this.open = false
        },
    },
}
</script>

<style>
.ab-sleep-btn { display: inline-flex; height: 2.25rem; align-items: center; gap: 0.25rem; border-radius: 9999px; padding: 0 0.625rem; font-size: 0.75rem; font-weight: 600; color: var(--ab-muted); transition: background-color 0.15s, color 0.15s; }
.ab-sleep-btn:hover { background: var(--ab-hover); color: var(--ab-ink); }
.ab-sleep-btn.is-on { color: var(--ab-accent); }
.ab-sleep-menu { position: absolute; right: 0; z-index: 10; width: 15rem; overflow: hidden; border-radius: 0.75rem; border: 1px solid var(--ab-line); background: var(--ab-bg); padding: 0.25rem 0; text-align: left; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1); }
.ab-sleep-item { display: flex; width: 100%; align-items: center; justify-content: space-between; padding: 0.625rem 1rem; font-size: 0.875rem; color: var(--ab-body); }
.ab-sleep-item:hover { background: var(--ab-hover); }
.ab-sleep-off { color: var(--ab-accent); }
.ab-pop-enter-active, .ab-pop-leave-active { transition: opacity 0.15s, transform 0.15s; }
.ab-pop-enter-from, .ab-pop-leave-to { opacity: 0; transform: translateY(4px); }
</style>
